import React, { useEffect, useCallback, useState } from "react";
import { X } from "lucide-react";
import { useContactModal } from "../context/ContactModalContext";
import Contact from "./Contact";

export default function ContactModal() {
  const { isOpen, closeContactModal } = useContactModal();
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setEntered(false);
      return;
    }
    const frame = requestAnimationFrame(() => {
      requestAnimationFrame(() => setEntered(true));
    });
    return () => cancelAnimationFrame(frame);
  }, [isOpen]);

  const handleEscape = useCallback(
    (e) => {
      if (e.key === "Escape") closeContactModal();
    },
    [closeContactModal]
  );

  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, handleEscape]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/55 backdrop-blur-md"
      onClick={(e) => e.target === e.currentTarget && closeContactModal()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="contact-modal-title"
    >
      <button
        type="button"
        onClick={closeContactModal}
        className="absolute right-4 top-4 z-[110] flex h-12 w-12 items-center justify-center rounded-full bg-white/95 text-gray-600 shadow-xl transition hover:bg-white hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-white/80"
        aria-label="Schließen"
      >
        <X className="h-6 w-6" strokeWidth={2.5} />
      </button>
      <div
        className={`relative w-full max-w-6xl max-h-[calc(100vh-2rem)] overflow-y-auto rounded-3xl bg-white shadow-[0_32px_80px_rgba(0,0,0,0.2)] transition-all duration-300 ease-out ${
          entered ? "scale-100 opacity-100" : "scale-95 opacity-0"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div id="contact-modal-title" className="sr-only">
          Kontaktformular
        </div>
        <Contact inModal />
      </div>
    </div>
  );
}
